/**
 * Extracted from sections/ns-upgrade-fitness-offer-v2.liquid (inline <script> at line 690).
 * Config bridge: window.__nsUfoV2InstallmentSections, keyed by section id. The Liquid the block
 * needed (its section id plus the settings listed in the bridge) is now
 * handed over as data, so the logic can live in a cacheable, deferred
 * asset instead of being parsed and compiled during the HTML parse
 * (INP work on the PDP). Boots once per registered section id.
 */

(function () {
  var cfg = window.__nsUfoV2InstallmentSections = window.__nsUfoV2InstallmentSections || {};
  function boot(nsSectionId, nsSettings) {
      (function () {
        var root = document.getElementById(`shopify-section-${nsSectionId}`);
        if (!root) return;

        var banner = root.querySelector('[data-ufo2-installments]');
        var priceEl = root.querySelector('[data-ufo2-installments-price]');
        var host = root.querySelector('shopify-payment-terms');
        if (!banner || !priceEl || !host) return;

        var POLL_MS = 300;
        var TIMEOUT_MS = 8000;
        var timer = null;

        // Shopify renders the amount inside its own shadow root, so reading it is
        // the only way to show it in the theme's own type. Every lookup is scoped
        // to THIS section's host — a second copy of the widget on the same page
        // (the PDP already ships one) must not be read by mistake.
        function readAmount() {
          if (!host.shadowRoot) return '';
          var content = host.shadowRoot.querySelector('#shopify-installments-content');
          if (!content) return '';
          var bold = content.querySelector('span.font-bold');
          return bold ? bold.innerHTML.trim() : '';
        }

        function stop() {
          if (timer) {
            window.clearInterval(timer);
            timer = null;
          }
        }

        function scrape() {
          stop();
          var elapsed = 0;
          timer = window.setInterval(function () {
            elapsed += POLL_MS;
            var amount = readAmount();
            if (amount) {
              stop();
              priceEl.innerHTML = amount;
              banner.hidden = false;
              return;
            }
            if (elapsed >= TIMEOUT_MS) {
              stop();
              // Not eligible, or the widget never rendered. The banner stays
              // hidden rather than showing a sentence with a hole in it.
            }
          }, POLL_MS);
        }

        scrape();

        // A variant change re-renders Shopify's widget with a new amount, so the
        // scraped copy has to be taken again or it goes stale.
        var form = document.forms[`${nsSettings.installmentFormId}`];
        if (form) {
          form.addEventListener('variant:change', scrape);
        }

        if (typeof Shopify !== 'undefined' && Shopify.designMode) {
          document.addEventListener('shopify:section:load', function (event) {
            if (event.detail && event.detail.sectionId === `${nsSectionId}`) scrape();
          });
          document.addEventListener('shopify:section:unload', function (event) {
            if (event.detail && event.detail.sectionId === `${nsSectionId}`) stop();
          });
        }

        if (window.MutationObserver) {
          var mo = new MutationObserver(function () {
            if (!document.body.contains(root)) {
              stop();
              mo.disconnect();
            }
          });
          mo.observe(document.body, { childList: true, subtree: true });
        }
      })();
  
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
